import React, { useCallback, useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Background from "./login.svg";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { TwinSpin } from "react-cssfx-loading/lib";
import { RenderLayout } from "../../../Plugin/component";
import { NotificationManager } from "react-notifications";

export default function ConfirmPageComponents(props) {
    const [openM, setOpenM] = useState(false);
    const [dataConfiguration, setDataPlanTypeConfiguration] = useState();
    const [url, setUrl] = useState();
    const [hidden, setHidden] = useState(false);
    const history = useHistory();
    const handleClose = () => {
        window.open("", "_self");
        window.close();
        //setOpenM(false);
    };
    const handleBackHome = () => {
        history.push("/")
    }

    useEffect(() => {
        const url = window.location.pathname.split('/');
        const planID = url[3];
        const HandleStep = url[5];
        const email = url[6] + '@fpt.com';
        setUrl(url[2]);
        var today = new Date();
        var date =
            today.getDate() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getFullYear();

        var time =
            today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        var dateTime = date + " " + time;
        if (url[2].includes('CF')) {
            let logs = {
                planID: planID,
                handleStaff: email,
                date: dateTime,
                action: url[2].includes('CF') ? 'Xác nhận' : 'Từ chối',
                step: HandleStep,
                difference: []
            }
            const DataPlan = {
                "PlanID": planID,
                "HandleStep": HandleStep,
                "Action": url[2].includes('CF') ? 'PLAN_CONFIRM' : 'PLAN_REJECT',
                "Email": email,
                "Logs": JSON.stringify(logs),
                "planContents": []
            }
            //console.log("DataPlan", DataPlan);
            //setTimeout(() => {
            props.GetDataConfirm(DataPlan);
            //}, 1000);
        }
        else {
            const DataPlan = {
                "ID": planID,
                "HandleStep": HandleStep
            }
            props.GetDataPlanHandleStep(DataPlan);
        }
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.DataPlan && Object.keys(props.DataPlan).length > 0) {
            setOpenM(true);
            setHidden(true);
        }
        else {
            //setTimeout(() => {
            setOpenM(true);
            //setTitle("Bạn đã xác nhận trước đó. Vui lòng kiểm tra lại !")
            //}, 700);
        }
    }, [props.DataPlan])

    useEffect(() => {
        if (props.DataPlanStep && props.DataPlanStep.length > 0) {
            setDataPlanTypeConfiguration(props.DataPlanStep);
        }

    }, [props.DataPlanStep])

    const HandleCovertEventToDateTime = useCallback((event, type) => {
        if (type === "Datetime") {
            const m = new Date(event);
            const mon = m.getMonth() + 1;
            const dateString =
                m.getFullYear() + "/" + mon + "/" + (m.getDate())
            return `${dateString.split(" ")[0]} ${new Date(event).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`;
        } else {
            return event
        }
        // eslint-disable-next-line
    }, [dataConfiguration]);

    const HandleOnChange = (e, index, Type, planTypeConfigurationID) => {
        function findOrange(fruit) {
            return fruit.planTypeConfigurationID === planTypeConfigurationID;
        }

        let oldIndex = dataConfiguration.findIndex(findOrange);

        //console.log("newIndex", oldIndex)
        setDataPlanTypeConfiguration([
            ...dataConfiguration.slice(0, oldIndex),
            {
                ...dataConfiguration[oldIndex],
                content: HandleCovertEventToDateTime(e, Type),
            },
            ...dataConfiguration.slice(oldIndex + 1),
        ]);
    };

    const checkNull = (value) => {
        let flag = 0;
        if (value && value.length > 0) {
            // eslint-disable-next-line
            value.map((item) => {
                if (item.content === '' || !item.content || item.content === null) {
                    flag = 1;
                }
            })
        }
        else {
            flag = 0;
        }
        return flag;
    }
    const handleReject = () => {
        const url = window.location.pathname.split('/');
        const planID = url[3];
        const HandleStep = url[5];
        const email = url[6] + '@fpt.com';
        var today = new Date();
        var date =
            today.getDate() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getFullYear();

        var time =
            today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        var dateTime = date + " " + time;
        if (dataConfiguration && dataConfiguration.length > 0) {
            const checkEmpty = dataConfiguration.filter((item) => item.name.includes('Lý do') || item.name.includes('từ chối') || item.name.includes('Lí do'));
            if (checkNull(checkEmpty) === 1) {
                NotificationManager.warning("Vui lòng nhập lý do từ chối!");
            }
            else {

                let logs = {
                    planID: planID,
                    handleStaff: email,
                    date: dateTime,
                    action: url[2].includes('CF') ? 'Xác nhận' : 'Từ chối',
                    step: HandleStep,
                    difference: []
                }
                const plancontentRJ = dataConfiguration && dataConfiguration.map((item) => {
                    return {
                        PlanTypeConfigurationID: item.planTypeConfigurationID,
                        PlanID: item.planID,
                        Content: item.content !== '' ? item.content : ''
                    }
                })
                const DataPlan = {
                    "PlanID": planID,
                    "HandleStep": HandleStep,
                    "Action": url[2].includes('CF') ? 'PLAN_CONFIRM' : 'PLAN_REJECT',
                    "Email": email,
                    "Logs": JSON.stringify(logs),
                    "planContents": plancontentRJ
                }
                //console.log("DataPlan", DataPlan);
                //setTimeout(() => {
                props.GetDataConfirm(DataPlan);
            }
        }
        else {
            NotificationManager.warning('Thao tác đã được xử lý trước đó!')
        }
    }
    const handleDownload = () => {

    }
    return (
        <div>
            <div className="img">
                <img src={Background} width="100%" height="990px" alt="img"/>
            </div>
            {openM === false &&
                <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                    <TwinSpin color="white" width="80px" height="80px" duration="0.5s" />
                </div>
            }
            <Dialog
                open={openM}
                //onClose={handleClose}
                fullWidth
                maxWidth={url === 'PlanCF' ? 'sm' : 'md'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    id="alert-dialog-title"
                    className="popupHandle"
                    style={{ color: "black", fontWeight: 'bold' }}
                >
                    Thông báo
                </DialogTitle>
                <DialogContent>
                    {url === 'PlanCF' ?
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ textAlign: "center", color: "black" }}
                        >
                            {props.DataPlan && Object.keys(props.DataPlan).length > 0 ? 'Xác nhận thành công !' : "Bạn đã hoàn tất thao tác trước đó. Vui lòng kiểm tra lại !"}
                            {/* {url === 'PlanRJ' &&
                        <div className="row">
                            <RenderLayout
                                data={dataConfiguration}
                                onChange={HandleOnChange}
                                handleDownload={handleDownload}
                            />
                        </div>} */}
                        </DialogContentText> :
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ textAlign: "center", color: "black" }}
                        >
                            {/* {props.DataPlan && Object.keys(props.DataPlan).length > 0 ? 'Xác nhận thành công !' : title} */}
                            {url === 'PlanRJ' && dataConfiguration && dataConfiguration.length > 0 ?
                                <div className="row" hidden={hidden}>
                                    <RenderLayout
                                        data={dataConfiguration}
                                        onChange={HandleOnChange}
                                        handleDownload={handleDownload}
                                    />
                                </div> : 'Bạn đã hoàn tất thao tác trước đó. Vui lòng kiểm tra lại !'}
                            {hidden === true && 'Từ chối thành công!'}
                            {/* {props.DataPlan && Object.keys(props.DataPlan).length > 0 && hidden ===true ? 'Từ chối thành công !' : "Bạn đã từ chối trước đó. Vui lòng kiểm tra lại!"} */}
                        </DialogContentText>
                    }

                </DialogContent>
                <DialogActions>
                    {url === 'PlanCF' ?
                        <Button
                            className="PlanTemplate_0021 text-light"
                            style={{ backgroundColor: "#6FB554" }}
                            onClick={handleBackHome}
                        >
                            Quay về trang chủ
                        </Button>
                        :
                        <Button
                            className="PlanTemplate_0021 text-light"
                            style={{ backgroundColor: "#6FB554" }}
                            onClick={handleReject}
                            hidden={hidden || !dataConfiguration || dataConfiguration.length === 0 ? true : false}
                        >
                            Từ chối
                        </Button>}
                    <Button
                        className="PlanTemplate_0021 text-light"
                        style={{ backgroundColor: "#DA9630" }}
                        onClick={handleClose}
                    >
                        Đóng trang
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    )
}
